export enum InvoiceListType {
    Consolidated = 1,
    Single = 2,
    Search = 0
}
